import { SizeType, VariantType } from '@/types';

export enum FILTER_OPTIONS_TYPE {
  STATIC = 'static',
  DYNAMIC = 'dynamic',
}

export enum FILTER_PLACEMENT {
  QUICK = 'quick',
  ADDITIONAL = 'additional',
}

export enum FILTER_TYPE {
  MULTICHECKBOX = 'multicheckbox',
}

export enum FILTER_TRIGGER_TYPE {
  BUTTON = 'button',
  ACCORDEON = 'accordeon',
}

export type FilterLabel = string;

export type FilterValue = string;

export type FilterConfigItem = {
  allStaticValues: FilterValue[];
  initialStaticValues: FilterValue[];
  fieldName: string;
  // Optional custom field accessor for nested fields (e.g., 'location.asset_type')
  // If not provided, uses direct field access: item[fieldName]
  fieldAccessor?: (item: any) => any;
  fieldValueToFilterValueMapping: (fieldValue: any) => FilterValue;
  filterOptionsType: FILTER_OPTIONS_TYPE;
  filterData: FilterData;
};

export type FilterConfig = Array<FilterConfigItem>;

type DropdownTriggerProps = {
  disabled?: boolean;
  variant?: VariantType;
  size?: SizeType;
};

export type FiltersValues = {
  [key: FilterLabel]: FilterValue[];
};

export type FilterOption = {
  id: string;
  label: string;
  realCounter?: number;
  futureCounter?: number;
  showCounter?: boolean;
  className?: string;
  hide?: boolean;
  disabled?: boolean;
};

export type FilterData = {
  filterLabel: FilterLabel;
  filterOptions: FilterOption[];
  placement: FILTER_PLACEMENT;
  filterType: FILTER_TYPE;
  triggerType: FILTER_TRIGGER_TYPE;
  triggerProps?: DropdownTriggerProps;
  disabled?: boolean;
};
